import { Controller } from "@hotwired/stimulus"
import AOS from "aos"

export default class extends Controller {
  connect() {
    AOS.init({
      once: true,
      duration: 800,
      easing: "ease-out-cubic",
      offset: 100,
      delay: 100,
      mirror: false,
    })
  }
}

